class TransferImportFile {
    constructor(
        name,
        type,
        content,
    ) {
        this.name = name;
        this.type = type;
        this.content = content;
    }

    getName() {
        return this.name;
    }

    getType() {
        return this.type;
    }

    getContent() {
        return this.content;
    }
}

export default TransferImportFile;
